var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-table',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"id":"exportTable","border":"","height":"300","data":_vm.tableData}},[_vm._l((_vm.exportFeild),function(item,index){return [_c('el-table-column',{key:index,attrs:{"property":item.prop,"label":item.label}})]})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4178b46c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/exportTable.vue
// module id = jlMx
// module chunks = 0